import React, { useState, useEffect } from 'react';
import Axios from '../../Components/Axios/Axios';
import Auth from '../../Components/Auth/Auth';
import { useHistory } from 'react-router-dom';
import { USER_KEY } from '../../Constants/index';
import { Button, Grid, Paper, InputAdornment, TextField, Autocomplete, MenuItem } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import FadeLoader from "react-spinners/FadeLoader";
import icon_success from '../../Images/Icons/success.png';
import icon_failed from '../../Images/Icons/error.png';
import dateFormat from 'dateformat';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import NumberFormat from 'react-number-format';

function ServiceList({ refresh }) {
    // For History
    const history = useHistory();

    // Set Loading
    const [loading, setLoading] = useState(false);

    // For Set Style Paper
    const paperStyle = { padding: 20, width: 'auto' }

    // Set data for thoundsand number format
    const USformatter = new Intl.NumberFormat("en-US");

    // For get Queue Info
    const [dataQueueID, setDataQueueID] = useState("");
    const [dataTimeStart, setDataTimeStart] = useState("");
    const [dataQueueNum, setDataQueueNum] = useState("");
    const [dataQueueDate, setDataQueueDate] = useState("");
    const [dataCusName, setDataCusName] = useState("");
    const [dataCusTel, setDataCusTel] = useState("");

    // function for Change Cus Name
    const changeCusName = (e) => {
        setDataCusName(e.target.value)
    }

    // function for Change Cus Tel
    const changeCusTel = (e) => {
        setDataCusTel(e.target.value)
    }

    // For get Employee Check-in Data
    const [dataProv, setDataProv] = useState("");
    const [dataSite, setDataSite] = useState("");
    const [dataCounter, setDataCounter] = useState("");
    const [dataCounterID, setDataCounterID] = useState("");

    // For get Service_Type to Filter and Service Choice
    const [dataServType, setDataServType] = useState([]);
    const [dataService, setDataService] = useState([]);
    const [foundServ, setFoundServ] = useState([]);

    // Set data for get item Service
    const [item, setItem] = useState([]);

    // For get data from user login
    const tokenData = JSON.parse(localStorage.getItem(USER_KEY));
    const token = tokenData.token;
    const _empID = tokenData.emp_info[0].emp_id;
    const _empCode = tokenData.emp_info[0].emp_code;

    // for Loading Data
    const loadData = async () => {
        setLoading(true)

        let _counterID = "";

        // For get Data Check-in
        try {
            await Axios.post("Emp/Check_in/Date", { "employee_id": _empID }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    let cycle = res.data.emp_check_in_list.length;
                    setDataProv(res.data.emp_check_in_list[cycle - 1].prov_name)
                    setDataSite(res.data.emp_check_in_list[cycle - 1].site_name)
                    setDataCounter(res.data.emp_check_in_list[cycle - 1].counter_name)
                    setDataCounterID(res.data.emp_check_in_list[cycle - 1].counter_id)
                    _counterID = res.data.emp_check_in_list[cycle - 1].counter_id
                }
            })
        } catch (error) {
            // console.log(error)
        }

        // For get Data Queue Info
        try {
            await Axios.post("Progress/Serivce/Data/Info", { "counter_id": _counterID }, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    setDataQueueID(res.data.queue_info[0].queue_id)
                    setDataTimeStart(dateFormat(res.data.queue_info[0].time_start, "HH:MM:ss"))
                    setDataQueueNum(res.data.queue_info[0].queue_number)
                    setDataQueueDate(dateFormat(res.data.queue_info[0].queue_date, "dd/mm/yyyy"))
                    setDataCusName(res.data.queue_info[0].cus_name)
                    setDataCusTel(res.data.queue_info[0].cus_tel)
                }
            })
        } catch (error) {
            // console.log(error)
        }

        // For get Data Service Choice
        try {
            await Axios.get("Service/Choice/All", { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == "200") {
                    setDataService(res.data.service_list)
                }
            })
        } catch (error) {
            // console.log(error)
        }

        // For get Data Service Type to Filter
        try {
            await Axios.get("Service/Type/All/Active", { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                // Check token Expired
                if (res.data.result_code == '403') {
                    Auth.logout(() => {
                        history.push("/");
                    });
                }

                if (res.data.result_code == '200') {
                    setDataServType(res.data.service_type_list)
                }
            })
        } catch (error) {
            // console.log(error)
        }

        setTimeout(() => {
            setLoading(false)
        }, 500);
    }

    useEffect(() => {
        loadData()
    }, [refresh])

    // Fouction for Filter Service with ServType
    const filterService = (e) => {
        const keyword = e.target.value;

        // Set FoundChar Filter
        if (keyword !== '') {
            const results = dataService?.filter((allService) => {
                return allService.type_name.startsWith(keyword);
            });
            setFoundServ(results);
        } else {
            setFoundServ(dataService);
        }
    }

    // Get value from Select Service Choice
    const [chooseServiceID, setChooseServiceID] = useState('');
    const serviceChange = (event) => {
        setChooseServiceID(event.target.value);
    }

    // For Dialog Cancel Queue
    const [confirmCancel, setConfirmCancel] = useState(false);

    // For Any Alert Success/Failed
    const [openCancelSuccess, setOpenCancelSuccess] = useState(false);
    const [openCancelFailed, setOpenCancelFailed] = useState(false);
    const [openSaveSuccess, setOpenSaveSuccess] = useState(false);

    // For Add New Item Service
    const AddItemService = () => {
        // Axios for get service detail and add to item
        let serviceData = {
            "service_id": chooseServiceID
        }

        Axios.post("Service/Info/With/ID", serviceData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
            if (res.data.result_code == "200") {
                let servID = res.data.service_info[0].service_id;
                let servName = res.data.service_info[0].service_name;
                let typeName = res.data.service_info[0].type_name;

                let new_update = ({ service_id: servID, service_name: servName, type_name: typeName, comment: "", service_price: 0, service_qty: 1 });
                setItem([...item, new_update])
            }
        })
    }

    // For Remove item with service id
    const Remove = (e) => {
        let update = item.filter(row => row.service_id !== e)
        setItem(update)
    }

    // For Edit Comment when input Comment Change
    const CommentChange = (e, id) => {
        let update = item.map((row, idx) => {
            if (idx === id) {
                row.comment = e
            }
            return row
        })
        setItem(update)
    }

    // For Edit Price when input Price Change
    const PriceChange = (e, id) => {
        let update = item.map((row, idx) => {
            if (idx === id) {
                row.service_price = e
            }
            return row
        })
        setItem(update)
    }

    // For Edit Qty when input Qty Change
    const QtyChange = (e, id) => {
        let update = item.map((row, idx) => {
            if (idx === id) {
                row.service_qty = e
            }
            return row
        })
        setItem(update)
    }

    // Sum Total Price
    let totalPrice = 0;
    if (item.length > 0) {
        let cycle = item.length;
        for (let i = 0; i < cycle; i++) {
            let _price = item[i].service_price;
            if (_price.length > 0) {
                let _conPrice = parseInt(_price.replaceAll(",", ""));
                totalPrice = totalPrice + _conPrice
            }
        }
    }

    // Function for Cancel Queue
    const cancelQueue = async () => {
        if (dataQueueID != "") {
            let cancelData = {
                "queue_id": dataQueueID,
                "update_by": _empCode
            }

            try {
                await Axios.post("Update/Progress/Status/Expired", cancelData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        setConfirmCancel(false);
                        setOpenCancelSuccess(true);
                    } else {
                        setConfirmCancel(false);
                        setOpenCancelFailed(true);
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    // Function for Save Service Item
    const saveServItem = async () => {
        if (dataQueueID != "" && item.length != 0) {
            let customerData = {
                "customer_name": dataCusName,
                "customer_tel": dataCusTel,
                "queue_id": dataQueueID,
                "counter_id": dataCounterID,
                "total": totalPrice,
                "update_by": _empCode
            }

            try {
                await Axios.post("Update/Queue/Customer/Info", customerData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                    // Check token Expired
                    if (res.data.result_code == '403') {
                        Auth.logout(() => {
                            history.push("/");
                        });
                    }

                    if (res.data.result_code == "200") {
                        let cycle = item.length;
                        for (let i = 0; i < cycle; i++) {
                            // ******* PRICE
                            let _conPriceItem = item[i].service_price;
                            // Check User remove 0
                            if (typeof (_conPriceItem) == "string" && _conPriceItem.length == 0) {
                                _conPriceItem = 0;
                            }

                            // Check User remove 0 and add new 0
                            if (typeof (_conPriceItem) == "string" && _conPriceItem == "0") {
                                _conPriceItem = 0;
                            }

                            // Convert When User add Value
                            if (typeof (_conPriceItem) == "string" && _conPriceItem.length != 0) {
                                _conPriceItem = parseInt(_conPriceItem.replaceAll(",", ""));
                            }

                            // ******* QTY
                            let _conQtyItem = item[i].service_qty;
                            // Check User remove 1
                            if (typeof (_conQtyItem) == "string" && _conQtyItem.length == 0) {
                                _conQtyItem = 1;
                            }

                            // Check User remove 1 and add new 1 OR 0
                            if (typeof (_conQtyItem) == "string" && (_conQtyItem == "1" || _conQtyItem == "0")) {
                                _conQtyItem = 1;
                            }

                            // Convert When User add Value
                            if (typeof (_conQtyItem) == "string" && _conQtyItem.length != 0) {
                                _conQtyItem = parseInt(_conQtyItem.replaceAll(",", ""));
                            }

                            // Axios for Insert New Queue Detail with item data
                            let queueDetData = {
                                "queue_id": dataQueueID,
                                "service_id": item[i].service_id,
                                "description": item[i].comment,
                                "service_price": _conPriceItem,
                                "service_qty": _conQtyItem
                            }

                            Axios.post("Add/New/Queue/Detail/Item", queueDetData, { headers: { Authorization: `Bearer ${token}` } }).then(res => {
                                if (res.data.result_code == "200") {
                                    console.log("OK")
                                }
                            })
                        }
                        setOpenSaveSuccess(true);
                    }
                })
            } catch (error) {
                // console.log(error)
            }
        }
    }

    return (
        <>
            {loading ? <>
                <div className='manage_loading'>
                    <FadeLoader color={'#ED1C24'} loading={loading} size={10} />
                </div>
            </> : <>
                {dataQueueNum && dataQueueNum.length > 0 ? <>
                    <div className='manage_title'>ເປີດບິນບໍລິການ</div>

                    <Paper elevation={10} style={paperStyle} className='manage_paper'>
                        <Grid container>
                            <Grid item xs={3}>
                                <Grid item xs={10} style={{ marginBottom: 10 }}>
                                    <span className='manage_input_label'>ແຂວງ:</span>
                                </Grid>

                                <Grid item xs={10}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        value={dataProv}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={10} style={{ marginBottom: 10 }}>
                                    <span className='manage_input_label'>ສູນບໍລິການ:</span>
                                </Grid>

                                <Grid item xs={10}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        value={dataSite}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={10} style={{ marginBottom: 10 }}>
                                    <span className='manage_input_label'>ປ່ອງບໍລິການ:</span>
                                </Grid>

                                <Grid item xs={10}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        value={dataCounter}
                                        disabled
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={6} style={{ marginBottom: 10 }}>
                                    <span className='manage_input_label'>ເລີ່ມນັບເວລາບໍລິການ:</span>
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        value={dataTimeStart}
                                        disabled
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid container style={{ marginTop: 20 }}>
                            <Grid item xs={3}>
                                <Grid container>
                                    <Grid item xs={4}>
                                        <Grid item xs={10} style={{ marginBottom: 10 }}>
                                            <span className='manage_input_label'>ລະຫັດຄິວ:</span>
                                        </Grid>

                                        <Grid item xs={10}>
                                            <TextField
                                                autoComplete='off'
                                                className='form-control mt-1'
                                                id="input-with-icon-textfield"
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                                value={dataQueueNum}
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={8}>
                                        <Grid item xs={9} style={{ marginBottom: 10 }}>
                                            <span className='manage_input_label'>ວັນທີ:</span>
                                        </Grid>

                                        <Grid item xs={9}>
                                            <TextField
                                                autoComplete='off'
                                                className='form-control mt-1'
                                                id="input-with-icon-textfield"
                                                size='small'
                                                variant='outlined'
                                                fullWidth
                                                value={dataQueueDate}
                                                disabled
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={10} style={{ marginBottom: 10 }}>
                                    <span className='manage_input_label'>ຊື່ລູກຄ້າ:</span>
                                </Grid>

                                <Grid item xs={10}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        value={dataCusName}
                                        onChange={changeCusName}
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={10} style={{ marginBottom: 10 }}>
                                    <span className='manage_input_label'>ເບີໂທລະສັບ:</span>
                                </Grid>

                                <Grid item xs={10}>
                                    <TextField
                                        autoComplete='off'
                                        className='form-control mt-1'
                                        id="input-with-icon-textfield"
                                        size='small'
                                        variant='outlined'
                                        fullWidth
                                        value={dataCusTel}
                                        onChange={changeCusTel}
                                    />
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={6} style={{ marginTop: 33 }}>
                                    <Button variant='outlined' className='manage_dialog_cancelQueue' color="error" onClick={() => { setConfirmCancel(true) }}>
                                        ຍົກເລີກຄິວ
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Paper>

                    <Paper elevation={10} style={paperStyle} className='manage_paper'>
                        <div className='manage_title'>ລາຍລະອຽດບໍລິການ</div>
                        <Grid container>
                            <Grid item xs={3}>
                                <Grid item xs={10}>
                                    <TextField id="limit" variant="outlined" size="small" select required onChange={filterService}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">ເລືອກປະເພດ:</InputAdornment>
                                        }}
                                        fullWidth>
                                        {dataServType.map((option) => (
                                            <MenuItem key={option.type_name} value={option.type_name}>
                                                {option.type_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>

                            <Grid item xs={6}>
                                <Grid item xs={11}>
                                    <TextField id="limit" variant="outlined" size="small" select required onChange={serviceChange}
                                        InputProps={{
                                            startAdornment: <InputAdornment position="start">ເລືອກບໍລິການ:</InputAdornment>
                                        }}
                                        fullWidth>
                                        {foundServ.map((option) => (
                                            <MenuItem key={option.service_id} value={option.service_id}>
                                                {option.service_name}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                </Grid>
                            </Grid>

                            <Grid item xs={3}>
                                <Grid item xs={4}>
                                    <Button variant='contained' onClick={AddItemService}>
                                        <AddIcon />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                        {item && item.length > 0 ? <>
                            <Grid container>
                                <Grid item xs={12} style={{ marginTop: 20 }}>
                                    <TableContainer component={Paper}>
                                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ລໍາດັບ</span></TableCell>
                                                    <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ປະເພດ</span></TableCell>
                                                    <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ບໍລິການ</span></TableCell>
                                                    <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ເນື້ອໃນບໍລິການ</span></TableCell>
                                                    <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ຈໍານວນບໍລິການ</span></TableCell>
                                                    <TableCell className='manage_table_header' align='left'><span className='manage_table_headtext'>ລາຄາທັງໝົດ</span></TableCell>
                                                    <TableCell className='manage_table_header' align='center'><span className='manage_table_headtext'>ຍົກເລີກ</span></TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {item.map((row, idx) => (
                                                    <TableRow key={idx}>
                                                        <TableCell align='center'><span className='manage_table_data'>{idx + 1}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.type_name}</span></TableCell>
                                                        <TableCell align='left'><span className='manage_table_data'>{row.service_name}</span></TableCell>
                                                        <TableCell align='left'>
                                                            <span className='manage_table_data'>
                                                                <TextField
                                                                    autoComplete='off'
                                                                    className='form-control mt-1'
                                                                    id="input-with-icon-textfield"
                                                                    size='small'
                                                                    variant='outlined'
                                                                    fullWidth
                                                                    value={row.comment}
                                                                    onChange={(e) => CommentChange(e.target.value, idx)}
                                                                />
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='right' width={200}>
                                                            <span className='manage_table_data'>
                                                                <NumberFormat
                                                                    autoComplete='off'
                                                                    className='form-control mt-1'
                                                                    id="input-with-icon-textfield"
                                                                    customInput={TextField}
                                                                    thousandSeparator={true}
                                                                    size='small'
                                                                    variant='outlined'
                                                                    fullWidth
                                                                    defaultValue="1"
                                                                    onChange={(e) => QtyChange(e.target.value, idx)}
                                                                />
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='right'>
                                                            <span className='manage_table_data'>
                                                                <NumberFormat
                                                                    InputProps={{
                                                                        endAdornment: <InputAdornment position="end">ກີບ</InputAdornment>
                                                                    }}
                                                                    autoComplete='off'
                                                                    className='form-control mt-1'
                                                                    id="input-with-icon-textfield"
                                                                    customInput={TextField}
                                                                    thousandSeparator={true}
                                                                    size='small'
                                                                    variant='outlined'
                                                                    fullWidth
                                                                    defaultValue="0"
                                                                    onChange={(e) => PriceChange(e.target.value, idx)}
                                                                />
                                                            </span>
                                                        </TableCell>
                                                        <TableCell align='center'><span className='manage_table_data'><div onClick={() => Remove(row.service_id)}><CloseIcon style={{ color: "red" }} /></div></span></TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>

                                            <TableRow>
                                                <TableCell colSpan={6} className='manage_table_header' align='right'><span className='manage_table_headtext'>ລວມຄ່າບໍລິການທັງໝົດ:</span></TableCell>
                                                <TableCell colSpan={1} className='manage_table_header' align='right'>
                                                    <span className='manage_table_headtext'>
                                                        {USformatter.format(totalPrice)} (ກີບ)
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            <Grid container style={{ marginTop: 30 }}>
                                <Grid item xs={10}></Grid>
                                <Grid item xs={2}>
                                    <Button className="manage_breake_button" fullWidth variant="outlined" onClick={saveServItem}>ບັນທຶກຂໍ້ມູນບໍລິການ</Button>
                                </Grid>
                            </Grid>
                        </> : <></>}
                    </Paper>
                </> : <>
                    <div className='manage_title'>ກະລຸນາກົດຮັບຄິວກ່ອນ...</div>
                </>}

                {/* Dialog Confirm Cancel Queue */}
                <Dialog
                    fullWidth={true}
                    open={confirmCancel}
                    maxWidth={"sm"}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialog_title'>
                            ຢືນຢັນການຍົກເລີກຄິວ
                        </div>
                    </DialogTitle>

                    <DialogContent style={{ marginBottom: 20 }}>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialog_content'>
                                ທ່ານຕ້ອງການຍົກເລິກຄິວນີ້ແທ້ ຫຼື ບໍ່ ?
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_saveBtn' onClick={cancelQueue}>
                                        ຕົກລົງ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={3}>
                                <div className='manage_dialog_action'>
                                    <Button variant='contained' className='manage_dialog_cancelBtn' onClick={() => { setConfirmCancel(false) }}>
                                        ກັບຄືນ
                                    </Button>
                                </div>
                            </Grid>
                            <Grid xs={2}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Cancel Success */}
                <Dialog
                    fullWidth={true}
                    open={openCancelSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ຍົກເລີກຄິວສໍາເລັດແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenCancelSuccess(false); history.push('/home/queue/create') }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Cancel Failed */}
                <Dialog
                    fullWidth={true}
                    open={openCancelFailed}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_failed} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບໍ່ສາມາດຍົກເລີກຄິວດັ່ງກ່າວໄດ້ ລອງໃຫມ່ອີກຄັ້ງ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_failedBtn' onClick={() => { setOpenCancelFailed(false); history.go(0) }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >

                {/* Dialog Alert Cancel Success */}
                <Dialog
                    fullWidth={true}
                    open={openSaveSuccess}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        <div className='manage_dialert_title'>
                            <img src={icon_success} width={120} />
                        </div>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <div className='manage_dialert_content'>
                                ບັນທຶກຂໍ້ມູນບໍລິການສໍາເລັດແລ້ວ !
                            </div>
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Grid container>
                            <Grid item xs={4}></Grid>
                            <Grid item xs={4}>
                                <div className='manage_dialert_action'>
                                    <Button type='submit' variant='contained' className='manage_dialert_successBtn' onClick={() => { setOpenSaveSuccess(false); history.push('/home/queue/create') }}>
                                        OK
                                    </Button>
                                </div>
                            </Grid>
                            <Grid item xs={4}></Grid>
                        </Grid>
                    </DialogActions>
                </Dialog >
            </>}
        </>
    )
}

export default ServiceList